// hooks/usePermission.js
import { useSelector } from 'react-redux';
import { selectCurrentAdmin } from '@/redux/auth/selectors';

export const usePermission = (moduleName) => {
    const currentAdmin = useSelector(selectCurrentAdmin);

    if (currentAdmin?.role === 'super_admin' || currentAdmin?.role === 'Admin') {
        return {
            canView: true,
            canCreate: true,
            canEdit: true,
            canDelete: true,
            canApprove: true,
            canExport: true,
        };
    }

    if (!currentAdmin?.permissions || !moduleName) {
        return {
            canView: false,
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canApprove: false,
            canExport: false,
        };
    }

    const modulePermissions = currentAdmin.permissions[moduleName] || [];

    return {
        canView: modulePermissions.includes('view'),
        canCreate: modulePermissions.includes('create'),
        canEdit: modulePermissions.includes('edit'),
        canDelete: modulePermissions.includes('delete'),
        canApprove: modulePermissions.includes('approve'),
        canExport: modulePermissions.includes('export'),
    };
};